import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Send, MessageSquare } from "lucide-react";

const SubmissionModal = ({ isOpen, onClose, onSubmit }) => {
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!description.trim()) {
      alert("Please describe your submission first.");
      return;
    }
    setIsSubmitting(true);
    try {
      await onSubmit({ description }); // hand description up to parent
      setDescription("");
      onClose();
    } catch (err) {
      console.error("❌ Submission failed:", err);
      alert("Something went wrong during submission.");
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm px-4"
        >
          <motion.div
            initial={{ scale: 0.96, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.96, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 180, damping: 20 }}
            className="relative w-full max-w-lg bg-white text-black rounded-2xl shadow-[0_8px_40px_rgba(0,0,0,0.15)] border border-neutral-200 p-6"
          >
            {/* === Close === */}
            <button
              onClick={onClose}
              className="absolute top-3 right-3 text-neutral-400 hover:text-black transition"
            >
              <X size={22} />
            </button>

            {/* === Header === */}
            <div className="flex items-center gap-2 mb-5">
              <MessageSquare size={20} className="text-black/70" />
              <h2 className="text-lg font-semibold tracking-tight">
                Submit Your Progress
              </h2>
            </div>

            <p className="text-sm text-neutral-600 mb-5 leading-relaxed">
              Summarize what you’ve accomplished so far. Keep it short — this is
              your checkpoint marker before Codi takes a look.
            </p>

            {/* === Input === */}
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Describe your progress..."
              rows={6}
              className="w-full text-sm text-black bg-white rounded-xl border border-neutral-300 
                         focus:ring-2 focus:ring-black/80 focus:border-black/80 outline-none p-3
                         placeholder:text-neutral-400 resize-none transition"
            />

            {/* === Actions === */}
            <div className="flex justify-end mt-6 gap-3">
              <button
                onClick={onClose}
                className="px-4 py-2 rounded-xl bg-neutral-100 text-neutral-700 text-sm font-medium
                           hover:bg-neutral-200 transition"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={isSubmitting}
                className="px-5 py-2 rounded-xl bg-black text-white text-sm font-semibold
                           hover:bg-neutral-800 transition disabled:opacity-40 flex items-center gap-2"
              >
                <Send size={16} />
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SubmissionModal;
